export { default } from './Summary.container';


// WEBPACK FOOTER //
// ./src/components/Summary/index.ts